/**
 * Card Payment Input Component
 */
import { getDeviceInfo } from '@/utils/deviceInfo';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPaymentMethods, initPayment } from 'src/redux/actions';
import { canDisablePlaceOrder } from 'src/utils/canDisablePlaceOrder';

const CardPaymentBox = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { store, orderDetails, loader, storeData, userData } = useSelector((state) => ({
    store: state.storeReducer.store,
    orderDetails: state.orderReducer.orderDetails,
    loader: state.commonReducer.loader,
    storeData: state.storeReducer.store,
    userData: state.userReducer.data,
  }));

  /**
   * UseEffect for prefilled card data
   */
  useEffect(() => {
    store?.store_id &&
      orderDetails?.order_hash &&
      dispatch(
        fetchPaymentMethods({
          store_id: store?.store_id,
          hash: orderDetails?.order_hash,
        })
      );
  }, []);

  const validateAll = () => {
    return true;
  };

  const checkForValidCardLogic = () => {
    return true;
  };

  const onPayBtnClick = () => {
    if (canDisablePlaceOrder()) {
      return;
    }
    if (validateAll() && checkForValidCardLogic()) {
      const data = {
        orderID: orderDetails?.order_hash,
        phone: userData?.phone,
        paymentMethod: 'card',
        merchantID: orderDetails?.merchant_id,
        deviceType: getDeviceInfo().OSName,
        browserType: getDeviceInfo().BrowserName,
        userAgent: getDeviceInfo().userAgent,
        source: 'longtail',
        merchantName: `Digital Showroom - ${storeData?.store_info?.name}`,
      };
      dispatch(initPayment(data, router));

      /**
       * This was added as to fix bank redirection after confirming OTP on our temporary domains, as the redirection
       * only happens on domain i.e. showroom.dotpe.in & not on our path -> showroom.dotpe.in/${domain},
       * so redirection details are saved here.
       */
      if (
        storeData?.store_info?.domain &&
        storeData?.store_info?.domain?.startsWith('d-temporary')
      ) {
        sessionStorage.setItem(
          'cardPaymentDetails',
          JSON.stringify({
            paymentMethod: 'card',
            redirectionUrl: storeData?.store_info?.store_url,
            storeDomain: storeData?.store_info?.domain,
          })
        );
      }
    }
  };

  function getCtaBtnText() {
    return props.isVerifyCard ? 'VERIFY NOW' : 'Pay';
  }

  return (
    <section className="card-payment-box">
      <div className="card-wrapper">
        <button
          onClick={onPayBtnClick}
          className={`cta-btn ${checkForValidCardLogic() ? `o-100 pointer` : `o-50`}`}
          disabled={loader || !checkForValidCardLogic()}
        >
          {!loader ? (
            getCtaBtnText()
          ) : (
            <img src={'/assets/images/ellipLoader1.gif'} className="img h1" />
          )}
        </button>
      </div>
    </section>
  );
};

export default CardPaymentBox;
